const e = (o, r = 16) => `${o / r}rem`;
export {
  e as transformPxToRem
};
//# sourceMappingURL=units.es.js.map
